import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClass = "", baseDelay = 0.15, stagger = 0.18 }) => (
  <span className={`block ${className}`}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: baseDelay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
